module.exports = __webpack_public_path__ + "static/img/bg-4.7d45d6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/bg-4.png
// module id = ENNZ
// module chunks = 1